import React, { useState, useEffect } from 'react';

const Banner = ({ 
  title = "Page Title", 
  subtitle = "Subtitle description", 
  imageSrc = "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
  height = "h-64" 
}) => {
  const [imageUrl, setImageUrl] = useState(imageSrc);
  const [imageError, setImageError] = useState(false);
  
  console.log('Banner component received imageSrc:', imageSrc);
  
  useEffect(() => {
    // Test if image loads successfully
    const img = new Image();
    img.onload = () => {
      console.log('Banner image loaded successfully:', imageSrc);
      setImageError(false);
      setImageUrl(imageSrc);
    };
    img.onerror = () => {
      console.error('Banner image failed to load:', imageSrc);
      setImageError(true);
      // Fallback to default image
      setImageUrl("https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80");
    };
    img.src = imageSrc;
  }, [imageSrc]);
  
  return (
    <div className={`relative ${height} bg-gray-200 flex items-center justify-center overflow-hidden`}>
      {/* Background Image */}
      {!imageError && (
        <img 
          src={imageUrl} 
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          onError={() => {
            console.error('Image element also failed to load:', imageUrl);
            setImageError(true);
          }}
        />
      )}
      
      
      {/* Content */}
      <div className="relative z-10 text-center text-white px-6">
        <h1 className="text-4xl md:text-5xl font-sans font-bold mb-4">{title}</h1>
        {subtitle && (
          <p className="text-lg md:text-xl opacity-90 max-w-2xl mx-auto">{subtitle}</p>
        )}
      </div>
      
      {/* Decorative gradient line */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-brand-gradient"></div>
    </div>
  );
};

export default Banner;